/* +----------------------------------+
 * | NOTE - PLEASE READ THIS!         |
 * | Use colors from @/config/colors! |
 * +----------------------------------+
 */

import { COLORS, MATERIAL_COLORS } from './../../config/colors';

const MATERIAL_COLORS_LIST = Object.values(MATERIAL_COLORS);

const HEAT_MAP_COLORS = {
    red: COLORS.heatmap_red,
    orange: COLORS.heatmap_orange,
    yellow: COLORS.heatmap_yellow,
    green: COLORS.heatmap_green,
    blue: COLORS.heatmap_blue,
    gray: COLORS.gray_nero
};

const ADDITIONAL_CI_COLORS = [
    COLORS.ci_blue_shade4,
    COLORS.ci_blue_shade3,
    COLORS.ci_blue_shade2,
    COLORS.ci_blue_shade1,
    COLORS.ci_blue_shade0
];


export default {
    // Returns all available colors; ideally shouldn't be used, though!
    getAllColors() {
        return {
            colors: Object.assign({ }, COLORS),
            materialColors: Object.assign({ }, MATERIAL_COLORS)
        };
    },

    // Get a color specified by either index or name; if nothing is specified, a random color from the list of colors is returned
    getColor(indexOrName) {
        if (typeof indexOrName === 'string' && MATERIAL_COLORS[indexOrName]) {
            return MATERIAL_COLORS[indexOrName];
        }
        else if (typeof indexOrName === 'number') {
            // Useful for counting up and getting a nicely ordered list of colors
            return MATERIAL_COLORS_LIST[indexOrName % MATERIAL_COLORS_LIST.length];
        }
        return MATERIAL_COLORS_LIST[Math.floor(Math.random() * MATERIAL_COLORS_LIST.length)];
    },

    // Provides a "stream" of colors that is based on the array of 24 colors defined above
    ColorGenerator: class {
        constructor(useCIColors = false) {
            const cache = { };
            const defaultStep = useCIColors ? 3 : 5;
            const colors = useCIColors ? ADDITIONAL_CI_COLORS : MATERIAL_COLORS_LIST;

            function* generator() {
                let counter = 0;
                for (;;) {
                    yield colors[counter];
                    counter = (counter + defaultStep) % colors.length;
                }
            }

            const generatorInstance = generator();

            this.getColor = itemKey => {
                if (!cache.hasOwnProperty(itemKey)) {
                    cache[itemKey] = generatorInstance.next().value;
                }
                return cache[itemKey];
            };

            this.getCache = () => cache;
        }
    },

    getPrimaryColor: () => COLORS.ci_blue_shade1,
    getPrimaryChartColor: () => COLORS.ci_blue_shade1,
    getSecondaryChartColor: () => COLORS.ci_blue_shade3,

    getChartColorRange: () => [
        COLORS.ci_blue_shade1,
        ...['orange', 'green', 'red', 'darkpurple', 'lightbrown', 'purple', 'gray', 'lime', 'cyan'].map(c => MATERIAL_COLORS[c])
    ],

    getCIColorRange: () => ADDITIONAL_CI_COLORS.slice(),
    
    getOperationsColors: () => ({
        red: MATERIAL_COLORS.red,
        yellow: MATERIAL_COLORS.amber,
        green: COLORS.green_sushi
    }),
    
    getParkingZonesColors: () => ({
        default: MATERIAL_COLORS.lightblue,
        highlight: MATERIAL_COLORS.cyan
    }),
    
    getRidehailingZonesColors: () => ({
        default: COLORS.gray_gainsboro,
        highlight: COLORS.gray_whisper
    }),
    
    getPinCircleColors: () => ({
        fillColor: MATERIAL_COLORS.cyan,
        strokeColor: MATERIAL_COLORS.cyan
    }),
    
    getHeatMapColors: () => Object.assign({ }, HEAT_MAP_COLORS),
    
    getExtendedHeatMapColors: () => Object.assign({ }, HEAT_MAP_COLORS, {
        violet: MATERIAL_COLORS.violet,
        yellow: MATERIAL_COLORS.yellow,
        lime: MATERIAL_COLORS.lime,
        teal: MATERIAL_COLORS.teal
    }),

    getHeatMapGradient() {
        const colors = Object.values(HEAT_MAP_COLORS);
        colors.pop();
        return [
            'rgba(0, 0, 0, 0)',
            ...colors.reverse()
        ];
    },

    getAlertCriticalityLevelColors: () => ({
        1: COLORS.red,
        2: COLORS.red_light,
        3: COLORS.orange,
        4: COLORS.yellow,
        5: COLORS.gray
    })
};